/* ============================================================
   gs-plp.js — Interacciones PLP estilo Gymshark (Serené)
   - Galería swipe: puntos indicadores por card
   - Toggle de grilla 1 <-> 2 columnas (persistente)
   - Wishlist (localStorage)
   - Botón "Filtrar y ordenar" -> abre el drawer nativo Dawn
   - Sync del conteo de productos con el motor de facetas
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. Galería swipe: puntos ---------- */
  function initScrollDots(root) {
    (root || document).querySelectorAll('[data-gs-scroller]').forEach(function (scroller) {
      var dotsWrap = scroller.parentElement.querySelector('[data-gs-dots]');
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.gs-card__dot');
      if (dots.length < 2) return;
      var ticking = false;
      scroller.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var idx = Math.round(scroller.scrollLeft / scroller.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          ticking = false;
        });
      }, { passive: true });
    });
  }

  /* ---------- 2. Toggle de grilla 1/2 columnas ---------- */
  function initGridToggle() {
    var grid = document.querySelector('[data-gs-grid]');
    var btns = document.querySelectorAll('[data-gs-cols]');
    if (!grid || !btns.length) return;
    var saved = localStorage.getItem('gs_plp_cols') || '2';
    apply(saved);
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-gs-cols');
        localStorage.setItem('gs_plp_cols', cols);
        apply(cols);
      });
    });
    function apply(cols) {
      grid.classList.toggle('is-single', cols === '1');
      btns.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-gs-cols') === cols);
      });
    }
  }

  /* ---------- 3. Wishlist ---------- */
  function initWishlist(root) {
    var store;
    try { store = JSON.parse(localStorage.getItem('gs_wishlist') || '[]'); }
    catch (e) { store = []; }
    (root || document).querySelectorAll('[data-gs-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (store.indexOf(id) !== -1) btn.classList.add('is-active');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var i = store.indexOf(id);
        if (i === -1) { store.push(id); btn.classList.add('is-active'); }
        else { store.splice(i, 1); btn.classList.remove('is-active'); }
        localStorage.setItem('gs_wishlist', JSON.stringify(store));
      });
    });
  }

  /* ---------- 4. Botón "Filtrar y ordenar" -> drawer nativo ---------- */
  function initFilterButton() {
    var trigger = document.querySelector('[data-gs-open-filters]');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var nativeSummary = document.querySelector('.mobile-facets__open-wrapper');
      if (nativeSummary) { nativeSummary.click(); }
    });
  }

  /* ---------- 5. Sync del conteo con facetas ---------- */
  function initCountSync() {
    var target = document.querySelector('[data-gs-count]');
    if (!target) return;
    function read() {
      var src = document.getElementById('ProductCount')
        || document.getElementById('ProductCountDesktop')
        || document.querySelector('.product-count__text');
      if (src && src.textContent.trim()) {
        var n = src.textContent.replace(/[^0-9]/g, '');
        if (n) target.textContent = n + ' Productos';
      }
    }
    read();
    var container = document.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      new MutationObserver(read).observe(container, { childList: true, subtree: true });
    }
  }

  /* ---------- 6. SEO "leer más" + FAQ ---------- */
  function initSeo() {
    var more = document.querySelector('[data-gs-seo-more]');
    var body = document.querySelector('[data-gs-seo-body]');
    if (more && body) {
      more.addEventListener('click', function () {
        if (body.hasAttribute('data-collapsed')) {
          body.removeAttribute('data-collapsed');
          more.textContent = 'Leer menos';
        } else {
          body.setAttribute('data-collapsed', '');
          more.textContent = 'Leer más';
        }
      });
    }
    document.querySelectorAll('.gs-faq__q').forEach(function (q) {
      q.addEventListener('click', function () {
        q.closest('.gs-faq__item').classList.toggle('is-open');
      });
    });
  }

  /* ---------- 7. Intro "Ver más" (descripción colapsable) ---------- */
  function initIntroMore() {
    var more = document.querySelector('[data-gs-intro-more]');
    var body = document.querySelector('[data-gs-intro-desc]');
    if (!more || !body) return;
    more.addEventListener('click', function () {
      if (body.hasAttribute('data-collapsed')) {
        body.removeAttribute('data-collapsed');
        more.textContent = 'Ver menos';
      } else {
        body.setAttribute('data-collapsed', '');
        more.textContent = '...Ver más';
      }
    });
  }

  /* ---------- 8. Botón "MÁS INFORMACIÓN" -> scroll suave a bloque ---------- */
  function initScrollTo() {
    document.querySelectorAll('[data-gs-scroll-to]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.querySelector(btn.getAttribute('data-gs-scroll-to'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- 9. Botón "Habla con la IA" -> abre el widget Aura (misma página) ---------- */
  function initAiChat() {
    document.querySelectorAll('[data-gs-ai-chat]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // El widget global (theme.liquid) expone window.SereneChat.open().
        // Guard + reintento corto por si aún no cargó (script defer).
        var tries = 0;
        (function openWhenReady() {
          if (window.SereneChat && typeof window.SereneChat.open === 'function') {
            window.SereneChat.open();
          } else if (tries++ < 20) {
            setTimeout(openWhenReady, 150);
          }
        })();
      });
    });
  }

  /* ---------- init + re-init tras render de facetas ---------- */
  function init(root) {
    initScrollDots(root);
    initWishlist(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initGridToggle();
    initFilterButton();
    initCountSync();
    initSeo();
    initIntroMore();
    initScrollTo();
    initAiChat();
  });

  // Dawn reemplaza #ProductGridContainer al filtrar -> re-enganchar cards
  if (window.MutationObserver) {
    document.addEventListener('DOMContentLoaded', function () {
      var container = document.getElementById('ProductGridContainer');
      if (!container) return;
      new MutationObserver(function () { init(container); })
        .observe(container, { childList: true, subtree: true });
    });
  }
})();
